import { Box, Card, Link, type TCardProps } from '@fe-toolkit/web-components'

import { DetailsListSeparator, EVisitType } from '@giffgaff/broadband-common'

import { EPageRoutes } from '@/constants'

import { EOrderStage, isStageBefore } from '@/components/pages/ChangeInstallDates/utils/propTypeHelpers'

import DetailsList, { DetailsListProps } from '../DetailsList/DetailsList'

import type { OrderDetail } from '@/api/schemas'

export type DetailsListCardProps = Pick<DetailsListProps, 'items' | 'separatorColour'> &
  Pick<TCardProps, 'backgroundColor' | 'marginBottom'> & {
    orderData?: OrderDetail
    visitType?: EOrderStage.PRE_WORK | EOrderStage.IN_HOME
  }

const DetailsListCard = ({
  backgroundColor = 'white',
  items,
  marginBottom,
  orderData,
  visitType,
  separatorColour = 'gallery',
}: DetailsListCardProps) => {
  const canManageInstall = () => {
    const appointments = orderData?.appointments ?? []
    const thisAppointment = appointments.find(appointment => appointment.visitType === visitType)

    if (!thisAppointment || !thisAppointment.amendable) return false

    const stage = orderData?.stage

    if (thisAppointment.visitType === EVisitType.PRE_WORK) {
      return stage === EOrderStage.VALIDATION || stage === EOrderStage.PRE_WORK
    } else if (thisAppointment.visitType === EVisitType.IN_HOME) {
      return stage === EOrderStage.VALIDATION || stage === EOrderStage.PRE_WORK || stage === EOrderStage.IN_HOME
    }

    return false
  }
  const createPluralForMultipleInstalls = (baseText: string, installCount: number) => {
    if (installCount < 2 || !isStageBefore(orderData?.stage as EOrderStage, visitType)) return baseText

    return `${baseText}s`
  }

  return (
    <Card backgroundColor={backgroundColor} marginBottom={marginBottom} padding="medium">
      <DetailsList items={items} separatorColour={separatorColour} />

      {canManageInstall() && (
        <>
          <DetailsListSeparator colour={separatorColour} />
          <Box testId="manage-install-link">
            <Link chevron fullWidth href={`${EPageRoutes.CHANGE_INSTALL_DATES}${orderData?.id}`}>
              {createPluralForMultipleInstalls('Manage your install', orderData?.appointments.length ?? 0)}
            </Link>
          </Box>
        </>
      )}
    </Card>
  )
}

export default DetailsListCard
